import { ca } from '@cian/analytics';

export function trackPrintButtonClicked() {
  ca('event', {
    action: 'print_open_tools',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackRemoveButtonClicked() {
  ca('event', {
    action: 'OfferPage',
    category: 'card',
    label: 'ClickDeleteButton',
    name: 'oldevent',
  });
}

export function trackUpgradeToPremiumClick() {
  ca('event', {
    action: 'premiun',
    category: 'Promote_ad_click',
    label: 'owner',
    name: 'oldevent',
  });
}

export function trackUpgradeToTop3Click() {
  ca('event', {
    action: 'top3',
    category: 'Promote_ad_click',
    label: 'owner',
    name: 'oldevent',
  });
}

export function trackUpgradeToPromotionClick() {
  ca('event', {
    action: 'promotion',
    category: 'Promote_ad_click',
    label: 'owner',
    name: 'oldevent',
  });
}
